import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

/**
 * Renderiza conteúdo editorial em HTML depois de remover marcação insegura.
 *
 * @param {object} props - Propriedades do componente
 * @param {string} props.html - HTML vindo da API
 * @param {string} props.className - Classes aplicadas ao contêiner
 * @returns {JSX.Element|null} Conteúdo seguro para apresentação
 */
const SanitizedHtml = ({ html = '', className = '' }) => {
  if (!html) return null;

  const sanitizedHtml = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });

  return <div className={className}>{parse(sanitizedHtml)}</div>;
};

SanitizedHtml.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
};

export default SanitizedHtml;
